import PropTypes from "prop-types"

export default function SectionHeader({ title, note, actions }) {
  return (
    <header className="composer-section-header">
      <div className="composer-section-header-top">
        <legend>{title}</legend>
        {actions}
      </div>
      {note && <p className="note remove-left-margin">{note}</p>}
    </header>
  )
}

SectionHeader.propTypes = {
  title: PropTypes.string.isRequired,
  note: PropTypes.node,
  actions: PropTypes.node,
}
